import type { PFrameInternal } from "@milaboratories/pl-model-middle-layer";
import type { IncomingHttpHeaders } from "node:http";

export function isGetOrHead(
  method: IncomingHttpHeaders["method"],
): method is PFrameInternal.HttpMethod {
  return method === "GET" || method === "HEAD";
}

export function isGet(
  method: PFrameInternal.HttpMethod,
): method is Extract<PFrameInternal.HttpMethod, "GET"> {
  return method === "GET";
}

export function isHead(
  method: PFrameInternal.HttpMethod,
): method is Extract<PFrameInternal.HttpMethod, "HEAD"> {
  return method === "HEAD";
}
